import React, { useState } from "react";

export default function BubbleSortGame() {
  const [numbers, setNumbers] = useState([6, 2, 5, 1, 4]);
  const [draggedIndex, setDraggedIndex] = useState(null);

  const numberStyle = {
    width: "50px",
    height: "50px",
    background: "#52ab98",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "20px",
    fontWeight: "bold",
    borderRadius: "8px",
    cursor: "grab",
    userSelect: "none",
  };

  function handleDragStart(index) {
    setDraggedIndex(index);
  }

  function handleDrop(index) {
    if (draggedIndex === null) return;

    const newNumbers = [...numbers];
    // swap the numbers
    [newNumbers[draggedIndex], newNumbers[index]] = [
      newNumbers[index],
      newNumbers[draggedIndex],
    ];
    setNumbers(newNumbers);
    setDraggedIndex(null);
  }

  return (
    <div style={{ fontFamily: "Arial, sans-serif", margin: "20px" }}>
      <h1 style={{ textAlign: "center", color: "#2b6777" }}>
        Bubble Sort Swap Game 🕹️
      </h1>
      <p style={{ textAlign: "center" }}>
        Drag one number and drop it on another number to swap them.
      </p>

      <div style={{ display: "flex", gap: "10px", justifyContent: "center" }}>
        {numbers.map((num, index) => (
          <div
            key={index}
            style={numberStyle}
            draggable
            onDragStart={() => handleDragStart(index)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => handleDrop(index)}
          >
            {num}
          </div>
        ))}
      </div>
    </div>
  );
}
